import type { ReactNode, VFC } from 'react';

import classNames from 'classnames';

import { Button } from '../Button/Button';

import * as styles from './ListHeader.module.scss';

interface ListHeaderProps {
  headerContent: ReactNode;
  buttonLabel?: ReactNode;
  onButtonClick?: () => void;
  className?: string;
  disableContentClip?: boolean;
}

const ListHeader: VFC<ListHeaderProps> = ({
  headerContent,
  buttonLabel,
  onButtonClick,
  className,
  disableContentClip = false,
}) => {
  const hasButton = buttonLabel && onButtonClick;

  return (
    <h2 className={classNames(styles.listHeader, className)}>
      <span
        className={classNames(styles.content, {
          [styles.clipContent]: !disableContentClip,
        })}
      >
        {headerContent}
      </span>
      {hasButton && (
        <Button
          onClick={onButtonClick}
          className={styles.button}
          variant="text"
          size="medium"
        >
          {buttonLabel}
        </Button>
      )}
    </h2>
  );
};

export { ListHeader };
